import { render, staticRenderFns } from "./ExtinguisherReportAdd.vue?vue&type=template&id=8397c718&"
import script from "./ExtinguisherReportAdd.vue?vue&type=script&lang=js&"
export * from "./ExtinguisherReportAdd.vue?vue&type=script&lang=js&"
import style0 from "./ExtinguisherReportAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports